module.exports = {
  COMPLETED: 'completed',
  DRAFT: 'draft',
  REFUNDED: 'refunded',
  VOID: 'void'
}
